import JsonSchema$anchorError from "./JsonSchema$anchorError.mjs";
class EvaluationJsonSchema$anchorError extends JsonSchema$anchorError {}
export default EvaluationJsonSchema$anchorError;